import 'slick-carousel';
import { TweenMax } from 'gsap';
import 'waypoints/lib/jquery.waypoints.min';

export default {
  init() {
    // JavaScript to be fired on all pages
    $('.menuBtn').click(function () {
      if($('#header').hasClass('active')){
        TweenMax.to($('.menu'), 0.3, {height: 0});
      }else{
        TweenMax.to($('.menu'), 0.3, {height:'auto'});
      }
      $('#header').toggleClass('active');
      $('body').toggleClass('show_menu');
    });

    $('#header .showMenu .menu .menu-item-has-children > a').click(function(e) {
      e.preventDefault();
      $(this).parents('.menu-item-has-children').toggleClass('active');
    })

    $('.waypoint_fadeIn').waypoint(function() {
      $(this.element).addClass('fadeIn_show')
    }, {
      offset: '80%',
    })
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js